import { TreeStructure } from "react-migration/components/CheckboxTree";
import { Nullable } from "src/js/types/Nullable";
import type * as actions from "./actions";

type AttributeKey = string;
type AttributeValue = string;

export const CONSTRAINT_STATUSES = ["adopted", "draft"] as const;
export type ConstraintStatus = (typeof CONSTRAINT_STATUSES)[number];

export type LayerState = {
  hiddenStatuses: ConstraintStatus[];
  visibleCategories: string[];
  hiddenDesignationAttributes: Record<AttributeKey, AttributeValue[]>;
  layerConfigHash: Nullable<string>;
  categoryTree: Nullable<TreeStructure>;
  displayBy: string;
};

export interface ConstraintsStore {
  layers: Record<string, LayerState>;
}

type ActionTypes = typeof actions;
export type ConstraintsStoreActionCreators = ActionTypes[keyof ActionTypes];
export type ConstraintsStoreAction = ReturnType<ConstraintsStoreActionCreators>;
export type ConstraintsStoreDispatch = React.Dispatch<ConstraintsStoreAction>;
